import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import PureRenderComponent from '../PureRenderComponent';


class AutocompleteOption extends PureRenderComponent {

    static propTypes = {
        search: PropTypes.string,
        value: PropTypes.any.isRequired,
        label: PropTypes.string,
        data: PropTypes.any,
        highlighted: PropTypes.bool,
        optionElement: PropTypes.func
    };

    static defaultProps = {
        role: 'option',
        label: '',
        highlighted: false,
        data: {},
        optionElement: null,
        search: null
    };

    componentDidUpdate (prevProps) {
        if (this.props.highlighted && !prevProps.highlighted) {
            this.refs.option.scrollIntoViewIfNeeded(false);
        }
    }

    _renderOptionChild () {
        if (!this.props.optionElement) {
            return this.props.label;
        }
        const OptionComponent = this.props.optionElement;

        return (
            <OptionComponent
                data={ this.props.data }
                search={ this.props.search }
            />
        );
    }

    render () {
        const { highlighted } = this.props;

        const classes = classnames('autocomplete__option', {
            'autocomplete__option--highlighted': highlighted
        });

        return (
            <div ref="option" className={ classes }>
                { this._renderOptionChild() }
            </div>
        );
    }

}


export default AutocompleteOption;
